import React, { useEffect, useState } from "react";
import { BookOpen, Download, ExternalLink } from "lucide-react";
import api from "@/lib/api";

export const TextbooksCard = ({ classId }) => {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    api.get(`/classes/${classId}/textbooks`).then((r) => setBooks(r.data)).catch(() => setBooks([]));
  }, [classId]);
  if (!books.length) return null;

  return (
    <div className="fade-up mb-6 rounded-xl border border-sky-300/20 bg-sky-300/[0.04] p-5" data-testid="textbooks-card">
      <div className="flex items-center gap-2 mb-4">
        <BookOpen className="w-4 h-4 text-sky-300" />
        <div className="font-display text-sm uppercase tracking-[0.15em] text-sky-300 font-semibold">NCERT Textbooks · 2026-27</div>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {books.map((b, i) => (
          <div key={b.title} className="rounded-lg border border-white/10 bg-[#152040] p-4 flex flex-col gap-3" data-testid={`textbook-${i}`}>
            <div>
              <div className="font-display font-semibold text-zinc-100" data-testid={`textbook-title-${i}`}>{b.title}</div>
              <div className="text-xs text-zinc-400">{b.chapters} · {b.edition}</div>
            </div>
            <div className="flex flex-wrap gap-2">
              <a href={b.book_url} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 rounded-full bg-sky-400 hover:bg-sky-300 text-slate-900 px-3 py-1.5 text-xs font-semibold transition-colors"
                data-testid={`textbook-open-${i}`}>
                <ExternalLink className="w-3.5 h-3.5" /> Open chapter PDFs
              </a>
              <a href={b.zip_url} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 rounded-full border border-white/15 hover:border-sky-300/50 text-zinc-200 px-3 py-1.5 text-xs transition-colors"
                data-testid={`textbook-zip-${i}`}>
                <Download className="w-3.5 h-3.5" /> Full book (ZIP)
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
